import { dataPackageUploadSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPackageUploadSolid = /*#__PURE__*/createIcon(dataPackageUploadSolid)
export default IconPackageUploadSolid
